import Post from "components/Docs/Post";

import {
  NAV_CONFIG_PATH,
  getShowStaticPaths,
  getShowStaticProps
} from "lib/mdx";

const USAGE_PATH = "usage";

export default Post;

export const getStaticPaths = getShowStaticPaths(USAGE_PATH);

export const getStaticProps = getShowStaticProps(USAGE_PATH, NAV_CONFIG_PATH);
